import { GET_TERMINOLOGIES } from "actions/constants";

const Terminologies = (state = {}, action) => {
  switch (action.type) {
    case GET_TERMINOLOGIES: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};
export default Terminologies;
